import axios from 'axios';
import { config } from '../config';

const apiClient = axios.create({
  headers: { 'Content-Type': 'application/json' },
});
apiClient.interceptors.request.use((reqConfig) => {
  reqConfig.baseURL = `${config.apiUrl}/api`;
  return reqConfig;
});

export interface InstagramPost {
  id: string;
  mediaType: 'IMAGE' | 'VIDEO' | 'CAROUSEL_ALBUM' | string;
  mediaUrl: string;
  thumbnailUrl?: string | null;
  permalink: string;
  caption?: string | null;
  timestampUtc: string;
}

export interface InstagramPostsResponse {
  username: string | null;
  posts: InstagramPost[];
}

export const instagramApi = {
  getPosts: async (siteNodeId: string): Promise<InstagramPostsResponse> => {
    const response = await apiClient.get<InstagramPostsResponse>('/instagram/posts', {
      params: { siteNodeId },
    });
    return response.data;
  },
};
